<template>
  <div>
    <van-search
      v-model="searchString"
      show-action
      placeholder="请输入收款方"
      @search="getPaymentRecord"
      @cancel="cancelSearch"
    />
    <van-row class="filter-nav">
      <van-col :span="8">支出类别
        <van-icon name="arrow"/>
      </van-col>
      <van-col :span="8">状态
        <van-icon name="arrow"/>
      </van-col>
      <van-col :span="8" @click="showFilterPanel=true">筛选
        <van-icon name="arrow"/>
      </van-col>
    </van-row>
    <div id="bothbox">
      <h2 id="btn">条件筛选</h2>
      <div class="title">
        查询成本外支出
      </div>
      <div class="boxcon">
        <li class="incon1">
          <input class="js-startdate-picker" type="text" placeholder="付款日期" v-model="selectBirthDate" readonly>
          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>
        </li>
        <li class="incon1">
          <input class="js-enddate-picker" type="text" placeholder="结束时间" v-model="enddate" readonly>
          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>
        </li>
        <li class="incon2">
          <input type="text" placeholder="收款方" id="btncon1" @click="toCus" ref="customer" readonly>
          <vue-pickers
            :show="isshow"
            :columns="columns"
            :selectData="customercon"
            @cancel="close1"
            @confirm="concus">
          </vue-pickers>
        </li>
        <li class="incon2">
          <input type="text" placeholder="支出类别" id="btncon" @click="toShow" ref="incomeGrp" readonly>
          <vue-pickers
            :show="show"
            :columns="columns"
            :defaultData="defaultData"
            :selectData="pickData"
            @cancel="close"
            @confirm="confirmFn"></vue-pickers>
        </li>
        <li class="incon2">
          <input type="text" placeholder="货币" id="btncon2" @click="toCurry" v-model="Currency" readonly>
          <vue-pickers
            :show="isshow2"
            :columns="columns"
            :selectData="currencyCon"
            @cancel="close2"
            @confirm="currycon">
          </vue-pickers>
        </li>

        <li class="incon2">
          <input type="text" placeholder="状态" id="btncon3" @click="tostate" v-model="State" readonly>
          <vue-pickers
            :show="isshow3"
            :columns="columns"
            :selectData="statecon"
            @cancel="close3"
            @confirm="stateCon">
          </vue-pickers>
        </li>
        <li class="incon2">
          <input type="text" placeholder="业务单元" readonly>
        </li>
        <li class="incon2">
          <input type="text" placeholder="业务子单元" readonly>
        </li>
      </div>
      <div class="footbot">
        <p id="Reset">重置</p>
        <p id="confirm" @click="btn()">确定</p>
      </div>
    </div>
  </div>
</template>

<script>
  import vuePickers from 'vue-pickers'

  export default {
    name: "findqueryout",
    components: {
      vuePickers
    },
    data() {
      return {
        show: false,
        isshow: false,
        isshow3: false,
        isshow2: false,
        columns: 1,
        isCopy: '',
        defaultData: [
          {
            text: '全部',
            value: '全部'
          }
        ],
        pickData: {
          // 第一列的数据结构
          data1: [
            {
              text: '全部',
              value: '全部'
            },
            {
              text: '未归类',
              value: '未归类'
            },
            {
              text: '内部转账',
              value: '内部转账'
            },
            {
              text: '经营活动收款',
              value: '经营活动收款'
            },
            {
              text: '投资活动收款',
              value: '投资活动收款'
            },
            {
              text: '筹资活动收款',
              value: '筹资活动收款'
            },
          ]
        },
        customercon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        currencyCon: {
          data1: [{
            text: '',
            value: ''
          }]
        },
        statecon: {
          data1: [
            {
              text: '全部',
              value: '全部'
            },
            {
              text: '应付',
              value: '应付'
            },
            {
              text: '已付',
              value: '已付'
            }
          ]
        },
        res: null,
        enddate: '',
        selectBirthDate: '',
        currencyList: [],
        stateList: ['全部', '应付', '已付'],
        customerList: [],
        costList: [],
        Currency: '',
        State: '',
      }
    },
    mounted() {
      this.BirthDateSelect();
      this.BirthEndDateSelect();
      this.GetCustomer();
      this.getcurrency()
    },
    methods: {
      apply() {
        this.$router.push({path: '/apply'})
      },
      BirthDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      BirthEndDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-enddate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      close() {
        console.log(123)
        this.show = false
      },
      close1() {
        console.log(123)
        this.isshow = false
      },
      close2() {
        console.log(123)
        this.isshow2 = false
      },
      close3() {
        console.log(123)
        this.isshow3 = false
      },
      confirmFn(val) {
        var btn = document.getElementById('btncon')
        console.log(val.select1.value)
        this.show = false
        btn.value = val.select1.value
        this.res = btn.value
        // console.log(JSON.parse(this.defaultData))
        this.defaultData = [val.select1[0]]
      },
      concus(val) {
        var btn2 = document.getElementById('btncon1')
        console.log(val.select1.value)
        this.isshow = false
        btn2.value = val.select1.value
        this.res = btn2.value
        // console.log(JSON.parse(this.defaultData))
      },
      stateCon(val) {
        var btn4 = document.getElementById('btncon3')
        this.isshow3 = false
        btn4.value = val.select1.value
        this.State = btn4.value
        // console.log(JSON.parse(this.defaultData))
      },
      currycon(val) {
        var btn3 = document.getElementById('btncon2')
        this.isshow2 = false
        btn3.value = val.select1.value
        this.Currency = btn3.value
        // console.log(JSON.parse(this.defaultData))
      },
      toShow(val) {
        this.show = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      toCus(val) {
        this.isshow = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      toCurry(val) {
        this.isshow2 = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      tostate(val) {
        this.isshow3 = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      screen() {
        var bothbox = document.getElementById('bothbox');
        var boxcon1 = document.getElementById("boxcon1")
        bothbox.style.transform = " translate(0,0)"
        bothbox.style.transitionDuration = "1s"
        boxcon1.style.display = 'block'
      },
      btn() {
        var bothbox = document.getElementById('bothbox');
        var boxcon1 = document.getElementById("boxcon1")
        bothbox.style.transform = "translate(2.68rem,0)"
        boxcon1.style.display = 'none'
      },
      getcurrency() {
        var currency = document.getElementById('currency')
        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res => {
          this.currencyList = res.data.result
          this.currencyCon.data1 = new Array();
          for (var i = 0; i < this.currencyList.length; i++) {
            this.currencyCon.data1.push({"text": this.currencyList[i].Code, "value": this.currencyList[i].Code})
          }

        })
      },
      GetCustomer() {
        var custormlog = document.getElementById('custormlog')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayeeJson',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.customerList = res.data.result
          // custormlog.style.display="block"
          this.customercon.data1 = new Array();
          for (var i = 0; i < this.customerList.length; i++) {
            this.customercon.data1.push({"text": this.customerList[i].Name, "value": this.customerList[i].Name})
          }
        })
      },
      currencycon(value, currency, decimals) {
        const digitsRE = /(\d{3})(?=\d)/g
        value = parseFloat(value)
        if (!isFinite(value) || (!value && value !== 0)) return ''
        currency = currency != null ? currency : '$'
        decimals = decimals != null ? decimals : 2
        var stringified = Math.abs(value).toFixed(decimals)
        var _int = decimals
          ? stringified.slice(0, -1 - decimals)
          : stringified
        var i = _int.length % 3
        var head = i > 0
          ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
          : ''
        var _float = decimals
          ? stringified.slice(-1 - decimals)
          : ''
        var sign = value < 0 ? '-' : ''
        return sign + currency + head +
          _int.slice(i).replace(digitsRE, '$1,') +
          _float
      },
      pay() {
        this.$router.push({path: '/pay'})
      },
      findpay() {
        this.$router.push({path: '/findpay'})
      },
      back() {
        this.$router.push('/home')
      },
    }
  }
</script>

<style lang="less" scoped>
  .filter-nav {
    background: white;
    text-align: center;
    padding: 1rem 0;
    margin-top: 1rem;

    .filter-btns {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  html, body {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  /*大盒子，首位固定*/
  .bigbox {
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;

  }

  .maincon {
    background: white;
    width: 100%;
    height: 42rem;
  }


  .header {
    height: 8rem;
    display: flex;
    flex-direction: column;
    background: white;
    overflow: hidden;
    border-bottom: 1px solid #e0e0e0;
  }

  #search {
    height: 5rem;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .hedT {
    width: 32rem;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 2.2rem;
  }

  .hedT input {
    display: block;
    width: 23rem;
    height: 2.8rem;
    padding-left: 3.3rem;
    border-radius: 20px;
    background: #f1f1f1;
    font-size: 1.2rem;
    margin-left: 1rem;

  }

  .hedT img {
    position: absolute;
    width: 1.3rem;
    height: 1.3rem;
    left: 2rem;
  }

  .hedB {
    display: flex;
    align-items: center;
    width: 3.6rem;
    height: 100%;
    color: black;
    margin-left: 1rem;
  }

  .inCon3 #currency p:last-child {
    text-align: center;
  }

  #choose {
    height: 3.3rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    background: white;
    padding: 0 3rem;
  }

  #choose li {
    height: 1.9rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.2rem;
    font-size: 1.4rem;
  }

  #choose li p {
    width: 6rem;
    color: #888888;
    text-align: center;
  }

  #choose li a {
    display: block;
    width: 11px;
    height: 7px;
  }

  #choose li:last-child a {
    display: block;
    width: 1.5rem;
    height: 1.4rem;
  }

  #choose li:nth-child(2) {
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc
  }

  #choose li a img {
    width: 100%;
    height: 100%;
  }

  #bothbox {
    width: 26.8rem;
    position: fixed;
    z-index: 3;
    height: 100%;
    background: white;
    top: 0;
    right: 0;
    transform: translate(2.68rem, 0);
    display: none
  }

  #bothbox h2 {
    display: block;
    height: 1.4rem;
    line-height: 1.4rem;
    color: #969696;
    margin-left: 1.8rem;
  }

  .title {
    height: 4rem;
    font-size: 1.2rem;
    margin-left: 2.3rem;
    line-height: 4rem;
    color: black;
  }

  .boxcon {
    padding: 0 0.17rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

  }

  .footbot {
    width: 100%;
    height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    border-top: 1px solid #ececec;
  }

  #Reset {
    width: 10rem;
    background: white;
    font-size: 1.1rem;
    color: black;
    line-height: 4rem;
    text-align: center;
  }

  #confirm {
    width: 17rem;
    background: #08a8be;
    font-size: 0.11rem;
    line-height: 0.4rem;
    text-align: center;
  }

  .incon1 {
    width: 9.6rem;
    height: 2.4rem;
    background: #f6f6f6;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 0.08rem;
    align-items: center;
    margin-left: 5px;
  }

  .incon1 p {
    color: black

  }

  .incon1 a {
    display: block;
    width: .9rem;
    height: .6rem;
  }

  .incon1 a img {
    width: 100%;
    height: 100%;
  }

  .incon1 input {
    display: block;
    width: 96px;
    height: 26px;
    background: #f6f6f6f6;
  }

  .incon2 {
    width: 7.5rem;
    height: 2.4rem;
    background: #f6f6f6;
    border-radius: 8px;
    margin-top: 10px;
    margin-left: 3px;
  }

  .incon2 input {
    display: block;
    width: 78px;
    margin-left: 4px;
    height: 26px;
    background: #f6f6f6f6;
    text-align: center;
    color: black;
    font-size: 1.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .incon2 a {
    color: black;
    display: block;
    text-align: center;
    line-height: 2.4rem
  }
</style>
